<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-03-26 
-->
<template>
  <div class="santen-container index">
    <div class="header">
      <div class="middle">
        <img :src="custom_report_detail.logo_path | logo_show" class="logo-img" @click="goback">
        <ul class="nav">
          <li class="on">
            <a @click="goback">返回首页</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="search-container">
      <div class="search-ipt">
        <i class="iconfont search-icon">&#xe6d7;</i>
        <Input v-model="params.keyword" @on-enter="handleRefreshList" placeholder="搜索标题、内容、实体、政策、适应症" />
        <Button @click="handleRefreshList">搜索</Button>
      </div>
    </div>
    <div class="search-result-container">
      <div class="article-btn">
        <RadioGroup v-model="params.search_type" @on-change="handleRefreshList">
          <Radio label="0" border>搜索标题</Radio>
          <Radio label="1" border>全文检索</Radio>
        </RadioGroup>
      </div>
      <div class="search-filter">
        <div class="filter-item">
          <Select v-model="params.sort_type" placeholder="排序规则" @on-change="handleRefreshList">
            <Option value="2">相关度降序</Option>
            <Option value="1">时间降序</Option>
          </Select>
          <DatePicker v-model="dateRange" class="date-range" type="daterange" placeholder="选择日期范围" format="yyyy-MM-dd" @on-change="handleChangeDate"></DatePicker>
          <Select class="categories-select" v-model="params.module_ids" placeholder="按栏目筛选" :max-tag-count="1" multiple @on-change="handleRefreshList">
            <Option :value="item.id" v-for="item in categories" :key="item.id">{{item.name}}</Option>
          </Select>
        </div>
        <div class="export-btn" v-if="list.length">
          <Button type="text" @click="handleExport">
            <Icon type="ios-download-outline" />导出所有搜索结果
          </Button>
        </div>
      </div>

      <div class="result-list">
        <div class="result-item" v-for="(item, index) in list" :key="index">
          <div class="result-item-img" v-if="item.content_type != '0'" @click="handleClickItem(item.src_url)">
            <img :src="item.logo_path | logo_show" />
          </div>
          <div class="result-item-content">
            <img :src="$store.state.static_img_url + 'pic/briefReport/slash.png'" class="slash" v-if="item.content_type == '0'">
            <div class="item-title" v-html="filter.keyWordHighLight(item.title, currentKeyword)" @click="handleClickItem(item.src_url)"></div>
            <div class="item-content" v-html="filter.keyWordHighLight(item.content, currentKeyword)"></div>
            <div class="item-footer">
              <span class="time">{{item.publish_time | time_moment('YYYY-MM-DD HH:mm')}}</span>
              <span class="period">第{{item.chapter_num}}期 {{item.chapter_title}}</span>
            </div>
          </div>
        </div>
        <div class="no-data" v-if="!list.length && !loading">
          <img :src="$store.state.static_img_url + 'pic/newsletter/nodata-icon.png'" />
          <p>没有找到相关的内容</p>
        </div>
        <div class="no-data2" v-if="list.length && !more && !loading">已经到底了</div>
        <Spin v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>

      <div ref="indexlist-bottom"></div>
    </div>
    <Spin fix v-if="pageLoading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <BackTop></BackTop>
  </div>
</template>
<script>
import {
  getReportContent,
  privatereport,
  getCustomReportContentList
} from '@/service'
import moment from 'moment'
import filter from 'js/filter'
import axios from 'axios'
export default {
  components: {},
  created() {
    this.params.keyword = this.$route.query.keyword
      ? decodeURIComponent(this.$route.query.keyword)
      : ''

    if (this.$route.query.uid && this.$route.query.name) {
      this.getCustomReportDetail()
    } else {
      this.$Message.error('链接参数错误！')
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        const listbox = this.$refs['indexlist-bottom']
        const listrect = listbox.getBoundingClientRect()
        const listabsoluteTop = listrect.top + scrollTop
        if (
          scrollTop + windowHeight > listabsoluteTop &&
          scrollTop > 0 &&
          !this.loading &&
          this.more
        ) {
          this.handleMore()
        }
      }, 10)
    })
  },
  beforeDestroy() {
    window.onscroll = ''
  },
  data() {
    return {
      filter,
      pageLoading: true,
      loading: false,
      more: false,
      custom_report_detail: {},
      dateRange: [],
      chapter_ids: [],
      categories: [],
      params: {
        chapter_ids: [], //【期刊id数组】
        start_time: '', //【开始时间】
        end_time: '', //【结束时间】
        uid: this.$route.query.uid, //【所属月报uid】
        page: 1,
        size: 30,
        module_ids: [], //【栏目id数组】
        keyword: '', //【关键词】
        sort_type: '2', //【排序方式，1时间降序（默认），2相关度降序】
        search_type: '0',
      },
      list: [],
      currentKeyword: '',
    }
  },
  computed: {},
  methods: {
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    /**
     * 获取简报和期刊信息
     */
    async getCustomReportDetail() {
      let res = await privatereport(
        {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
        },
        (error) => this.$Message.error('请求错误！')
      )
      this.pageLoading = false
      if (res.status == 'success') {
        this.$set(this.$data, 'custom_report_detail', res.res[0])
        this.chapter_ids = res.chapter.map((item) => item.id)
        this.getReportContent()
        this.handleRefreshList()
      } else {
        this.$Message.error(res.message)
      }
    },
    async getReportContent() {
      let res = await getReportContent(
        {
          start_time: '',
          end_time: '',
          chapter_ids: this.chapter_ids,
        },
        (error) => this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'categories', res.res)
      } else {
        this.$Message.error('请求错误！')
      }
    },
    handleChangeDate() {
      this.params.start_time = this.dateRange[0]
        ? moment(this.dateRange[0]).format('YYYY-MM-DD')
        : ''
      this.params.end_time = this.dateRange[1] ? moment(this.dateRange[1]).format('YYYY-MM-DD') : ''
      this.handleRefreshList()
    },
    async getCustomReportContentList() {
      this.loading = true
      this.currentKeyword = this.params.keyword
      if(!this.currentKeyword) {
        this.list = []
        this.params.page = 1
        this.loading = false
        return
      }
      let res = await getCustomReportContentList(this.params, (error) =>
        this.$Message.error('请求错误！')
      )
      this.loading = false
      if (res.status == 'success') {
        this.list = [...this.list, ...res.res]
        this.more = res.res.length == 30
      } else {
        this.$Message.error('请求错误！')
      }
    },
    handleRefreshList() {
      this.params.page = 1
      this.list = []
      this.getCustomReportContentList()
    },
    handleMore() {
      this.params.page++
      this.getCustomReportContentList()
    },
    handleExport() {
      const { size, page, ...params} = this.params
      axios
        .post(
          this.$store.state.req_url + '/dg/downloadCustomReportContentList',
          JSON.stringify(params),
          {
            headers: {
              'content-Type': 'application/json; charset=UTF-8',
            },
            responseType: 'blob',
          }
        )
        .then((response) => {
          this.exportParams(response)
        })
        .catch((error) => {
          this.$Message.error('请求错误!')
        })
    },
    exportParams(url) {
      const aLink = document.createElement('a');
      const blob = new Blob([url.data], {
        type: "application/vnd.ms-excel"
      });
      // 创建一个当前文件的内存URL
      const _href = URL.createObjectURL(blob);
      aLink.style.display = 'none';
      aLink.href = _href;
      document.body.appendChild(aLink);
      aLink.setAttribute('download', this.custom_report_detail.title + '_数据导出_' + moment().format('YYYYMMDDHHmmss') +'.xlsx');
      aLink.click();
      document.body.removeChild(aLink);
      // 手动释放创建的URL对象所占内存
      URL.revokeObjectURL(_href);

      this.$nextTick(() => {
        this.$Message.success('导出成功!')
      })
    },
    goback() {
      const { uid, name } = this.$route.query
      this.$router.push({
        name: 'Newsletter',
        query: {
          uid,
          name,
        },
      })
    },
    handleClickItem(src_url) {
      window.open(src_url, '_blank')
    },
  },
}
</script>
<style lang='stylus' scoped>
@import './style/santen.stylus'
.santen-container
  .logo-img
    max-width 200px !important
    max-height 40px !important
    width auto
    height auto
.index
  min-height 100vh
  padding 68px 0 20px
  >>> .ivu-back-top-inner
    background-color #fff
    i
      color #999
    &:hover
      i
        color #FA5A00
.search-container
  padding 30px 0 20px
  display flex
  justify-content center
  .search-ipt
    margin-top 0
.search-result-container
  width 1200px
  margin 0 auto
  padding 30px 170px
  background #FFFFFF
  .search-filter
    display flex
    align-items center
    justify-content space-between
    padding-bottom 20px
    .filter-item
      margin-right 16px
      .date-range
        width 240px
        margin-right 10px
        >>> .ivu-icon-ios-close-circle
          cursor pointer
        >>> .ivu-input
          box-shadow none
          &:focus, &:hover
            border-color #dcdee2
      .ivu-select
        width 120px
        margin-right 10px
        &.categories-select
          width 200px
          border-color #dcdee2
      >>> .ivu-select-selection
        box-shadow none
        &-focused, &:hover
          border-color #dcdee2
    .export-btn
      margin-left auto
      .ivu-btn
        display flex
        align-items center
        color #FA5A00
        padding 0
        height auto
        box-shadow none
        &:hover
          color #FF4800
        .ivu-icon
          margin-right 4px
          font-size 16px
  .article-btn
    font-size 0
    margin-bottom 20px
    >>> .ivu-radio-wrapper
      margin-right 10px
      .ivu-radio
        display none
      &.ivu-radio-wrapper-checked
        border-color #FA5A00
        color #FA5A00
  .result-list
    .result-item
      padding 16px 0
      display flex
      &-img
        overflow hidden
        flex 0 0 242px
        max-width 242px
        min-width 242px
        height 152px
        cursor pointer
        img
          width 100%
          height 100%
          transition all 0.5s
        &:hover
          img
            transform scale(1.1)
      &-content
        position relative
        padding-left 20px
        flex auto
        display flex
        flex-direction column
      .slash
        position absolute
        left 0
        top 2px
        width 10px
        height 18px
      .item-footer
        margin-top 18px
        font-size 14px
        color #666
        display flex
        justify-content space-between
      .item-title
        font-size 16px
        font-weight 700
        color #333
        line-height 22px
        margin-bottom 10px
        cursor pointer
        transition all 0.3s
        &:hover
          color #FA5A00
      .item-content
        font-size 16px
        color #333
        line-height 28px
        flex auto
      >>> .high-light
        color #FA5A00
        font-style normal
    .no-data2
      font-size 14px
      color #A5B4E6
      line-height 42px
      text-align center
    .no-data
      padding 60px 0
      line-height 1
      text-align center
      img
        width 30px
        height 30px
        margin-bottom 12px
      p
        font-size 14px
        color #A5B4E6
</style>